/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useMemo } from 'react';

import { MainCoreModuleContext } from './contexts';
import { MainCoreModule } from '../../../../../core-modules/main-core-module';

import type { MainCoreModuleConfig } from '../../../../../core-modules/main-core-module';

export interface MainCoreModuleProviderProps {
    coreModuleConfig: MainCoreModuleConfig;
    children: React.ReactNode;
}

export const MainCoreModuleProvider = ({ coreModuleConfig, children }: MainCoreModuleProviderProps) => {
    const coreModule = useMemo(() => new MainCoreModule(coreModuleConfig), [coreModuleConfig]);

    return (
        <MainCoreModuleContext.Provider value={coreModule}>
            {children}
        </MainCoreModuleContext.Provider>
    );
};
